import './Confirmation.css';

const Confirmation = ({ data }) => {
  return (
    <div className="confirmation-container">
      {data.sections.map((section, index) => (
        <div key={index} className="section">
          <h3 className="section-title">{section.section_title}</h3>
          <ul className="fields-list">
            {section.fields.map((field, idx) => (
              <li key={idx}>
                <span className="bold-label">{field.label}:</span> {field.value}
              </li>
            ))}
          </ul>
        </div>
      ))}

      <p className="confirmation-prompt">{data.confirmation_prompt}</p>
    </div>
  );
};

export default Confirmation;
